module.exports = __webpack_public_path__ + "images/mdj/members/message/outboxlist/outboxlist_icon01-5b0c3714f49b167a90f670c28e1ab037.png";